module.exports = __webpack_public_path__ + "img/cart-plus.085e626b.svg";